// extracted by mini-css-extract-plugin
export default {"br_logo":"ImgFrame_br_logo__NZgBP"};